import React from "react";
import { Flex } from "@fluentui/react-northstar";

export interface IFieldWithLabelProps {
    label?: string;
    value?: string;
}

const FieldWithLabel: React.FunctionComponent<IFieldWithLabelProps> = ({ label, value }) => (
    <Flex column>
        <small>{label}</small>
        <div dangerouslySetInnerHTML={{__html: value ?? ""}}></div>
    </Flex>
);

export default FieldWithLabel;
